import React, { useState } from 'react';
import { fitnessProfileSurfaceMutedClassName } from './shared/fitnessProfileReadingStyles';

export default function FitnessProfileThisWeekCalendar({
	meals = [],
	workouts = [],
	mealBullets = [],
	workoutBullets = []
}) {
	if (!meals.length && !workouts.length) return null;

	const workoutsByDay = new Map(workouts.map((item) => [item.day, item]));
	const orderedDays = meals.map((entry) => entry.day);
	const [selectedDay, setSelectedDay] = useState(orderedDays[0] || null);
	const activeMeal = meals.find((entry) => entry.day === selectedDay) || meals[0];
	const activeWorkout = workoutsByDay.get(activeMeal?.day);

	return (
		<div className="space-y-4">
			{(mealBullets.length > 0 || workoutBullets.length > 0) && (
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
					<div className={fitnessProfileSurfaceMutedClassName}>
						<div className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">
							Weekly Nutrition Rules
						</div>
						<ul className="mt-1.5 list-disc pl-4 text-xs text-gray-600 dark:text-gray-300 space-y-1">
							{mealBullets.map((bullet) => (
								<li key={`rule-meal-${bullet}`}>{bullet}</li>
							))}
						</ul>
					</div>
					<div className={fitnessProfileSurfaceMutedClassName}>
						<div className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">
							Weekly Training Rules
						</div>
						<ul className="mt-1.5 list-disc pl-4 text-xs text-gray-600 dark:text-gray-300 space-y-1">
							{workoutBullets.map((bullet) => (
								<li key={`rule-workout-${bullet}`}>{bullet}</li>
							))}
						</ul>
					</div>
				</div>
			)}

			<div className="overflow-x-auto pb-1 lg:overflow-visible">
				<div className="flex gap-2.5 min-w-max lg:min-w-0 lg:grid lg:grid-cols-7">
					{meals.map((entry) => {
						const workout = workoutsByDay.get(entry.day);
						const isActive = entry.day === (activeMeal?.day || selectedDay);
						return (
							<button
								type="button"
								key={`week-${entry.day}`}
								onClick={() => setSelectedDay(entry.day)}
								className={`w-44 lg:w-auto text-left rounded-xl border p-3 transition ${
									isActive
										? 'border-blue-500 bg-blue-50 dark:bg-blue-900 dark:bg-opacity-20'
										: `${fitnessProfileSurfaceMutedClassName} hover:bg-gray-50 dark:hover:bg-gray-800`
								}`}
							>
								<div className="text-sm font-semibold text-gray-900 dark:text-gray-100">{entry.day}</div>
								<div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
									{entry.meals.length} meals
								</div>
								<div className="mt-1 text-xs font-medium text-gray-700 dark:text-gray-300 truncate">
									{workout ? workout.focus : 'No workout'}
								</div>
							</button>
						);
					})}
				</div>
			</div>

			{activeMeal && (
				<div className={`${fitnessProfileSurfaceMutedClassName} p-4`}>
					<div className="text-sm font-semibold text-gray-900 dark:text-gray-100">
						{activeMeal.day} Details
					</div>
					<div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
						<div>
							<div className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">
								Meals
							</div>
							<ul className="mt-1.5 list-disc pl-4 text-xs text-gray-600 dark:text-gray-300 space-y-1">
								{activeMeal.meals.map((meal) => (
									<li key={`detail-${activeMeal.day}-${meal}`}>{meal}</li>
								))}
							</ul>
						</div>
						<div>
							<div className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">
								Workout
							</div>
							{activeWorkout ? (
								<>
									<div className="mt-1.5 text-xs font-semibold text-gray-900 dark:text-gray-100">
										{activeWorkout.focus}
									</div>
									<div className="mt-0.5 text-xs text-gray-600 dark:text-gray-300">
										{activeWorkout.detail}
									</div>
									{activeWorkout.bullets?.length > 0 && (
										<ul className="mt-1.5 list-disc pl-4 text-xs text-gray-600 dark:text-gray-300 space-y-1">
											{activeWorkout.bullets.map((bullet) => (
												<li key={`detail-${activeMeal.day}-${bullet}`}>{bullet}</li>
											))}
										</ul>
									)}
								</>
							) : (
								<div className="mt-1 text-xs text-gray-500 dark:text-gray-400">No workout scheduled</div>
							)}
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
